var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.333h-2.667V0H11v1.333H8.667V0H7.333v1.333H5V0H3.667v1.333H1c-.551 0-1 .449-1 1V15c0 .551.449 1 1 1h14c.551 0 1-.449 1-1V2.333c0-.551-.449-1-1-1zM3.667 2.667V4H5V2.667h2.333V4h1.334V2.667H11V4h1.333V2.667h2.334v2.666H1.333V2.667h2.334zm-2.334 12v-8h13.334v8H1.333z",
    fill: "#333"
  })));
};
export default SvgCalendarIcon;